module.exports = __webpack_public_path__ + "static/media/sale-3.87084ce9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sale-3.jpg
// module id = 506
// module chunks = 33